/**
 * /usecases/developer-left — a PAGE. AppLayoutRoute supplies the chrome.
 * Content lives in ../data/cases.ts; the template renders it.
 */
import { UseCaseTemplate } from '../components/UseCaseTemplate';

export default function DeveloperLeftPage() {
  return <UseCaseTemplate slug="developer-left" />;
}
